<template>
    <svg
        :class="{
            'icon__instagram': hoverState == true
        }"
        width="20"
        height="20"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="instagramIconTitle"
    >
        <title id="instagramIconTitle">Instagram logo</title>
        <path
            d="M10 1.8c-2.63 0-3 .01-4 .06a5.61 5.61 0 0 0-1.9.34 3.33 3.33 0 0 0-1.9 1.9A5.61 5.61 0 0 0 1.86 6c-.06 1-.06 1.37-.06 4s.01 3 .06 4a5.61 5.61 0 0 0 .34 1.9 3.33 3.33 0 0 0 1.9 1.9 5.61 5.61 0 0 0 1.94.3c1 .06 1.37.06 4 .06s3-.01 4-.06a5.61 5.61 0 0 0 1.86-.34 3.33 3.33 0 0 0 1.9-1.9 5.61 5.61 0 0 0 .34-1.86c.06-1 .06-1.37.06-4s-.01-3-.06-4a5.61 5.61 0 0 0-.38-1.9 3.33 3.33 0 0 0-1.9-1.9A5.61 5.61 0 0 0 14 1.86c-1-.06-1.33-.06-4-.06zM10 0c2.72 0 3.06 0 4.12.06.83.02 1.65.175 2.43.46a4.85 4.85 0 0 1 1.77 1.16 4.85 4.85 0 0 1 1.16 1.77c.285.78.44 1.6.46 2.43C20 6.94 20 7.28 20 10s-.06 3.06-.06 4.12a7.59 7.59 0 0 1-.46 2.43 5.19 5.19 0 0 1-2.93 2.93c-.78.285-1.6.44-2.43.46-1.06.06-1.4.06-4.12.06s-3.06 0-4.12-.06a7.59 7.59 0 0 1-2.43-.46 4.85 4.85 0 0 1-1.77-1.16 4.85 4.85 0 0 1-1.16-1.77 7.59 7.59 0 0 1-.46-2.43C0 13.06 0 12.72 0 10s0-3.06.06-4.12c.02-.83.175-1.65.46-2.43a4.85 4.85 0 0 1 1.16-1.77A4.85 4.85 0 0 1 3.45.52 7.59 7.59 0 0 1 5.88.06C6.94 0 7.28 0 10 0zm0 4.86a5.14 5.14 0 1 1 0 10.28 5.14 5.14 0 0 1 0-10.28zm0 8.47a3.33 3.33 0 1 0 0-6.66 3.33 3.33 0 0 0 0 6.66zm5.34-7.47a1.2 1.2 0 1 1 0-2.4 1.2 1.2 0 0 1 0 2.4z"
            fill="#F2F2F2"
            fill-rule="nonzero"
        />
    </svg>
</template>

<script>
export default {
    name: 'IconInstagram',
    props: {
        hoverState: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/all.scss';

.icon__instagram {
	path {
		transition: all 0.3s ease;
	}
    &:hover {
        path {
            fill: $primary;
        }
    }
}
</style>
